import { useTranslation } from "react-i18next";

export default function ErrorFallback({
  resetError,
}: {
  error: unknown;
  resetError: () => void;
}) {
  const { t } = useTranslation();
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col items-start justify-center gap-4 px-6 py-16">
      <h1 className="text-2xl font-semibold">
        {t("errors.boundary.title", "Something went wrong")}
      </h1>
      <p className="text-muted-foreground leading-relaxed">
        {t(
          "errors.boundary.body",
          "An unexpected error occurred. The team has been notified. Please try again, or refresh the page.",
        )}
      </p>
      <div className="flex gap-2">
        <button
          onClick={resetError}
          className="rounded-lg bg-slate-900 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-white"
        >
          {t("errors.boundary.retry", "Try again")}
        </button>
        <button
          onClick={() => window.location.reload()}
          className="rounded-lg border border-slate-300 bg-white px-5 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-800"
        >
          {t("errors.boundary.reload", "Reload page")}
        </button>
      </div>
    </main>
  );
}
